import React, { FC } from 'react';
import { IchiPositionsDetails } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/IchiPositionsDetails';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const IchiLiquidityDetails: FC<Props> = ({ mintInfo }) => {
  const { mode, provider, currencyA, currencyB, strategy } =
    useLiquidityWizardState();

  const { poolAddress } = mintInfo;

  if (
    mode === 'auto' &&
    provider === 'ichi' &&
    poolAddress &&
    currencyA &&
    currencyB
  ) {
    return (
      <IchiPositionsDetails
        poolAddress={poolAddress}
        currencyA={currencyA}
        currencyB={currencyB}
      />
    );
  }
};
